var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { maintenanceApi } from '../rest/api';
export var maintenanceKeys = Object.freeze({
    all: ['maintenance'],
    info: function (tenantId) {
        return __spreadArray(__spreadArray([], __read(maintenanceKeys.all), false), [tenantId], false);
    },
});
function getMaintenanceInfo(context) {
    var _a = __read(context.queryKey, 2), tenantId = _a[1];
    if (!tenantId) {
        throw new Error('Invalid query, no tenant id');
    }
    return maintenanceApi.get(tenantId);
}
export function useMaintenanceInfo(tenantId, options) {
    var _a;
    var key = maintenanceKeys.info(tenantId);
    var enabled = ((_a = options === null || options === void 0 ? void 0 : options.enabled) !== null && _a !== void 0 ? _a : true) && tenantId !== undefined;
    return useQuery(key, getMaintenanceInfo, __assign(__assign({}, options), { enabled: enabled }));
}
function setMaintenance(variables) {
    return maintenanceApi.set(variables.tenantId, { maintenance: variables.value });
}
export function useSetMaintenance() {
    var queryClient = useQueryClient();
    return useMutation(setMaintenance, {
        onMutate: function (variables) {
            var key = maintenanceKeys.info(variables.tenantId);
            var oldInfo = queryClient.getQueryData(key);
            queryClient.setQueryData(key, function (info) {
                if (info) {
                    return __assign(__assign({}, info), { maintenance: variables.value });
                }
            });
            return { oldInfo: oldInfo };
        },
        onError: function (error, variables, context) {
            var _a;
            var key = maintenanceKeys.info(variables.tenantId);
            queryClient.setQueryData(key, (_a = context) === null || _a === void 0 ? void 0 : _a.oldInfo);
        },
        onSettled: function (data, error, variables, context) {
            var key = maintenanceKeys.info(variables.tenantId);
            return queryClient.invalidateQueries(key);
        },
    });
}
